import PropTypes from "prop-types";
import React from "react";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  TouchableWithoutFeedback,
  ScrollView,
  Animated,
  ActivityIndicator,
} from "react-native";
import { styleSheet } from "app/utils/styleSheet";
import Text from "app/components/Text";
import valueHelpers from "app/utils/valueHelpers";
import textHelpers from "app/utils/textHelpers";
import frequencyHelpers from "app/utils/frequencyHelpers";
import valueActions from "app/utils/valueActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import store from "app/redux/store";

import TextInput from "app/components/TextInput";
import ButtonGroup from "app/components/ButtonGroup";
import ValueNote from "app/components/ValueNote";

import {
  Ionicons,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

import { StyleContext } from "app/contexts/Style";

export default class ValueNoteList extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    value: PropTypes.object.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    let children = valueHelpers.getChildren({
      value: props.value,
      includeNotes: true,
    });
    this.state = {
      showFilters: false,
      wrap: false,
      sortBy: "created_at",
      order: "newest",
      query: "",
      filters: this.defaultFilters(children),
    };
  }

  defaultFilters = (children = []) => {
    let hasOpenChildren = !!children.find((c) => !c.completed_at);
    // let hasBodiedChildren = !!children.find((c) => !!c.text?.length);
    // let hasParentingChildren = !!children.find((c) => !!c.child_ids?.length);
    return {
      projects: true,
      tasks: true,
      trackers: true,
      notes: true,
      hide_complete: hasOpenChildren,
      hide_no_body: false,
      hide_no_children: false,
    };
  };

  render() {
    let { value } = this.props;
    let { showFilters, wrap } = this.state;
    let { sortBy, order, filters, query } = this.state;

    let children = valueHelpers.getChildren({
      value,
      includeNotes: true,
    });

    if (order == "newest") {
      children = textHelpers.newestFirst(children, sortBy);
    } else {
      children = textHelpers.oldestFirst(children, sortBy);
    }

    let hiddenIds = children
      .map((c) => (this.determineHidden(c) ? c.id : null))
      .filter((x) => !!x);

    return (
      <View>
        <ScrollView
          horizontal
          // style={{ width: "100%", borderWidth: 2, borderColor: "red", flex: 1 }}
          // style={{ width: "100%" }}
          contentContainerStyle={
            {
              // flex: 1,
              // minWidth: this.context.sizes.WIDTH - 50,
              // borderWidth: 2,
              // borderColor: "blue",
            }
          }
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              padding: this.context.sizes.base,
              // height: this.context.sizes.large + this.context.sizes.tiny,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Ionicons
                name="filter"
                size={this.context.sizes.smallItemHeight}
                color={this.context.colors.foreground}
                onPress={() => this.setState({ showFilters: !showFilters })}
                style={[
                  { marginRight: this.context.sizes.base },
                  showFilters && {
                    transform: [{ rotateZ: "-90deg" }],
                  },
                ]}
              />
              {showFilters && (
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginRight: this.context.sizes.large,
                  }}
                >
                  <Text>Sort by: </Text>
                  <ButtonGroup
                    small
                    selected={sortBy}
                    options={[
                      { text: "Created", value: "created_at" },
                      { text: "Updated", value: "updated_at" },
                    ]}
                    onSelect={(val) => this.setState({ sortBy: val })}
                  />
                  <Text
                    smallButton
                    onPress={() => {
                      this.setState({
                        order: order == "newest" ? "oldest" : "newest",
                      });
                    }}
                  >
                    {order == "newest" ? "Newest" : "Oldest"}
                  </Text>
                </View>
              )}
              {showFilters && (
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <Text>Filters: </Text>
                  {Object.keys(filters).map((key, i) => {
                    let active = filters[key];
                    return (
                      <Text
                        key={i}
                        smallButton
                        selectedButton={active}
                        onPress={() => {
                          console.log("change", key, "to", !active);
                          filters[key] = !active;
                          this.setState({ filters });
                        }}
                      >
                        {textHelpers.humanize(key)}
                      </Text>
                    );
                  })}
                  <Ionicons
                    name="md-refresh"
                    size={this.context.sizes.large}
                    color={this.context.colors.foreground}
                    onPress={() =>
                      this.setState({
                        filters: this.defaultFilters(children),
                        sortBy: "created_at",
                        order: "newest",
                        query: "",
                      })
                    }
                    style={{ marginRight: this.context.sizes.large }}
                  />
                  <Text style={{ opacity: 0.6 }}>
                    ( {children.length - hiddenIds.length} / {children.length} )
                  </Text>
                </View>
              )}
            </View>
            <View style={{ flexDirection: "row" }}>
              <TextInput
                value={query}
                // style={{ maxWidth: 100, borderWidth: 2, borderColor: "green" }}
                placeholder={"Search..."}
                onChangeText={(query) => this.setState({ query })}
              />
              <MaterialCommunityIcons
                name={
                  wrap
                    ? "format-text-wrapping-overflow"
                    : "format-text-wrapping-wrap"
                }
                size={this.context.sizes.large}
                color={this.context.colors.foreground}
                onPress={() => this.setState({ wrap: !wrap })}
              />
            </View>
          </View>
        </ScrollView>

        <ScrollView
          horizontal
          contentContainerStyle={[
            { flexDirection: "row" },
            wrap && { flex: 1, flexWrap: "wrap" },
          ]}
          style={{
            padding: this.context.sizes.base,
            marginBottom: this.context.sizes.large,
          }}
        >
          {children.map((child, i) => {
            //let hidden = this.determineHidden(child);
            let hidden = hiddenIds.includes(child.id);
            // if (hiddenIds?.includes(child.id)) return null;
            return (
              <View
                key={i}
                style={
                  hidden
                    ? { width: 0, overflow: "hidden" }
                    : {
                        marginBottom: this.context.sizes.small,
                        marginBottom: this.context.sizes.large,
                        marginRight: this.context.sizes.large,
                        zIndex: 999 - i,
                      }
                }
              >
                <ValueNote
                  key={`${i}-${child.id}`}
                  ref={(r) => (this[`ref-${i}`] = r)}
                  value={child}
                  handleFocusPrevious={() => {
                    this[`ref-${i - 1}`]?.focus();
                  }}
                  handleFocusNext={() => {
                    this[`ref-${i + 1}`]?.focus();
                  }}
                  // width={200}
                />
              </View>
            );
          })}
        </ScrollView>
      </View>
    );
  }

  determineHidden = (value) => {
    let { filters, query } = this.state;
    let hidden = false;
    if (!filters.projects && valueHelpers.isProject(value)) hidden = true;
    else if (!filters.tasks && valueHelpers.isTask(value)) hidden = true;
    else if (!filters.trackers && valueHelpers.isTracker(value)) hidden = true;
    else if (!filters.notes && value.is_note) hidden = true;
    else if (
      filters.hide_complete &&
      (!!value.completed_at || !!value.archived_at)
    )
      hidden = true;
    else if (filters.hide_no_body && !value.text?.length) hidden = true;
    else if (filters.hide_no_children && !value.child_ids?.length)
      hidden = true;

    if (!hidden && !!query?.length) {
      hidden = true;
      if (value.title?.includes(query) || value.text?.includes(query)) {
        hidden = false;
      }
    }

    // children = children.filter((value) => value.cycle != null);

    return hidden;
  };

  styles = () => {
    return {};
  };
}
